import React, { FunctionComponent } from "react";
import { Badge, Skeleton } from "@chakra-ui/react";
import { useIntl } from "react-intl";

interface IProps {
  state?: number;
}

const CONVERTER_STATE = {
  NONE: 0,
  OK: 1,
  WARNING: 2,
  OFF: 3,
  ERROR: 4,
}

const ConverterState: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case CONVERTER_STATE.NONE:
      return (
        <Badge colorScheme={"gray"}>
          {intl.formatMessage({
            id: "converter__state__none",
            defaultMessage: "-",
          })}
        </Badge>
      )
    case CONVERTER_STATE.OK:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "converter__state__ok",
            defaultMessage: "OK",
          })}
        </Badge>
      )
    case CONVERTER_STATE.WARNING:
      return (
        <Badge variant="solid" colorScheme={"yellow"}>
          {intl.formatMessage({
            id: "converter__state__warning",
            defaultMessage: "WARNING",
          })}
        </Badge>
      )
    case CONVERTER_STATE.ERROR:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "converter__state__error",
            defaultMessage: "ERROR",
          })}
        </Badge>
      )
    case CONVERTER_STATE.OFF:
      return (
        <Badge variant="solid" colorScheme={"blue"}>
          {intl.formatMessage({
            id: "converter__state__off",
            defaultMessage: "OFF",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default ConverterState;
